/**
 * sidebar 制御
 */
if($('#multicolumn-sidebar').length) {
  /**
   * サイドバーの表示サイズを設定
   * @type   {Function}
   * @return {Number}   設定するサイドバーの表示サイズ
   */
  let setSidebarDisplay = 342;

  /**
   * ターゲットとなる要素を設定
   * @type   {Function}
   * @return {Object}
   */
  let setTgtElem = function() {
    let targetElem;
    if ($('.container').length) {
      targetElem = $('.container');
    } else {
      targetElem = $('.container-fluid');
    }
    return targetElem;
  }

  /**
   * サイドバーの制御
   * @type {Function}
   */
  let sidebarOperation = function() {
    /**
     * サイドバーの表示サイズを取得
     * @type {Number}
     */
    let sidebarDisplay = setSidebarDisplay;
    if($(window).width() < 1025) {
      /**
       * タッチデバイス用コード
       */
      if(parseInt($('#sidebar--second').css('left')) === (0 - sidebarDisplay)){
        $('#sidebar--first').animate({
          left: 0
        }, 300);
        $('#sidebar--second').animate({
          left: 64
        }, 300);
      } else {
        $('#sidebar--first').animate({
          left: (0 - 64)
        }, 300,function () {
          $('#sidebar--first').attr('style', '');
        });
        $('#sidebar--second').animate({
          left: (0 - sidebarDisplay)
        }, 300,function () {
          $('#sidebar--second').attr('style', '');
        });
      }
    }
  };

  /**
   * Sidebarの表示・非表示制御
   * @namespace .abuiSidebar
   */
  $(document).off('click.abuiSidebar', '.js-sidebar-toggle');
  $(document).on('click.abuiSidebar', '.js-sidebar-toggle', function() {
    sidebarOperation();
  });

  /**
   * タッチデバイスでサイドバー領域外をタップした時
   */
  $(document).off('touchend.abuiSidebar');
  $(document).on('touchend.abuiSidebar', function(e){
    /**
     * サイドバーの表示サイズを取得
     * @type {Number}
     */
    let sidebarDisplay = setSidebarDisplay;
    if($(e.target).closest('.wrapper').length) {
      $('#sidebar--first').animate({left:0-64},300,function(){$('#sidebar--first').attr('style','')});
      $('#sidebar--second').animate({left:0-sidebarDisplay},300,function(){$('#sidebar--second').attr('style','')});
    }
  });

  $(document).find('.wrapper').off('click.abuiSidebar');
  $(document).on('click.abuiSidebar', '.wrapper', function() {
    /**
     * サイドバーの表示サイズを取得
     * @type {Number}
     */
    let sidebarDisplay = setSidebarDisplay;

    /**
     * ターゲットとなる要素を取得
     * @type {Object}
     */
    let container = setTgtElem();
    if(parseInt($('.sidebar').css('left')) == 0 && parseInt(container.css('margin-left')) != sidebarDisplay){
      $('.sidebar').animate({
        left: (0 - sidebarDisplay)
      }, 300,function () {
        $('.sidebar').attr('style', '');
      });
    }
  });

  /**
   * ネストされたsidebar内メニュー項目の開閉処理
   */
  // $(document).off('.abuiSidebar', '.expander');
  // $(document).on('click.abuiSidebar', '.expander', function(){
  //   $(this).toggleClass('open').nextAll('.expander-target').slideToggle('fast');
  //   if($(this).hasClass('open') == false) {
  //     const subSection = $(this).nextAll('.expander-target').find('.expander');
  //     subSection.removeClass('open').nextAll('.expander-target').slideUp('fast');
  //   }
  //   // リンクがないメニューをクリックした時は無効
  //   if($(this).children('a').hasClass('temp-linkless')) {
  //     return false;
  //   }
  // });
}
